
export class CBNGameConfig{
    gameType:GameType;
    gameElement:HTMLDivElement|null;
    gameData:any;
    willPracticePlay:PracPlay;
    willDisplayHTP:boolean;
    willDisplayTitle:boolean;
    onGameLevelComplete: (score:number,gameName:string, pracPlay:string)=>void;
    onGameEnd: (score:number,gameName:string, pracPlay:string)=>void;
    previousScore:number;
    customTimeLimit:number|null;

    constructor(gameType:GameType,gameElement:HTMLDivElement|null,gameData:any
        ,willPracticePlay:PracPlay ,willDisplayHTP:boolean, willDisplayTitle:boolean, onGameLevelComplete:(score:number,gameName:string, pracPlay:string)=>void
        ,onGameEnd: (score:number,gameName:string, pracPlay:string)=>void,previousScore:number,customTimeLimit:number|null){

        this.gameType = gameType;
        this.gameElement = gameElement;
        this.gameData = gameData;
        this.willPracticePlay = willPracticePlay;
        this.willDisplayHTP = willDisplayHTP;
        this.willDisplayTitle = willDisplayTitle;
        this.onGameLevelComplete = onGameLevelComplete;
        this.onGameEnd = onGameEnd;
        this.previousScore = previousScore;
        this.customTimeLimit = customTimeLimit;
    }
}

export enum GameType{
    daily = "daily",
    single = "single",
    full = "full"
}

export enum PracPlay{
    play = "play",
    practice = "practice",
    option = "option"
}


